import { Module } from './module';
import { Status } from './status';

/** Verbos HTTP con los que se puede mapear un menú de tipo acción */
export const MENU_MAPPING_TYPES = ['GET', 'POST', 'PUT', 'DELETE'] as const;
export type MenuMappingType = typeof MENU_MAPPING_TYPES[number];

export class Menu {
  id?: number;
  title?: string;
  titleEnglish?: string;
  description?: string;
  descriptionEnglish?: string;
  icon?: string;
  backgroundUrl?: string;
  link?: string;
  position?: number;
  module?: Module = new Module();
  parent?: Menu = {};
  isMenu?: boolean = true;
  isBlank?: boolean = false;
  /**
   * El link es un sitio externo que se incrusta dentro de la app (columna
   * is_embedded). En ese caso `link` guarda la URL del sitio.
   */
  isEmbedded?: boolean = false;
  /**
   * La opción es una acción (columna is_action) y no una pantalla. Es
   * excluyente con `isBlank` e `isEmbedded`.
   */
  isAction?: boolean = false;
  /** Verbo HTTP con el que se mapea la acción: GET, POST, PUT o DELETE (columna mapping_type) */
  mappingType?: MenuMappingType = null;
  status?: Status = new Status();
  createdAt?: Date = new Date();
  updatedAt?: Date;
  children?: Menu[] = [];
}
